import {
    FETCH_USER_SUBSCRIPTIONS_REQUEST,
    FETCH_USER_SUBSCRIPTIONS_SUCCESS,
    FETCH_USER_SUBSCRIPTIONS_ERROR,
    UPDATE_USER_SUBSCRIPTIONS_REQUEST,
    UPDATE_USER_SUBSCRIPTIONS_SUCCESS,
    UPDATE_USER_SUBSCRIPTIONS_ERROR,
} from '../constants/ActionTypes';

export function isFetchingSubscriptions(state = false, action) {
    switch (action.type) {
        case FETCH_USER_SUBSCRIPTIONS_REQUEST:
            return true;
        case FETCH_USER_SUBSCRIPTIONS_ERROR:
        case FETCH_USER_SUBSCRIPTIONS_SUCCESS:
            return false;
    }
    return state;
}

export function fetchSubscriptionsError(state = false, action) {
    switch (action.type) {
        case FETCH_USER_SUBSCRIPTIONS_REQUEST:
            return state;
        case FETCH_USER_SUBSCRIPTIONS_SUCCESS:
            return false;
        case FETCH_USER_SUBSCRIPTIONS_ERROR:
            return true;
    }
    return state;
}

export function isUpdatingSubscriptions(state = false, action) {
    switch (action.type) {
        case UPDATE_USER_SUBSCRIPTIONS_REQUEST:
            return true;
        case UPDATE_USER_SUBSCRIPTIONS_ERROR:
        case UPDATE_USER_SUBSCRIPTIONS_SUCCESS:
            return false;
    }
    return state;
}

export function updateSubscriptionsError(state = null, action) {
    switch (action.type) {
        case UPDATE_USER_SUBSCRIPTIONS_REQUEST:
            return null;
        case UPDATE_USER_SUBSCRIPTIONS_SUCCESS:
            return null;
        case UPDATE_USER_SUBSCRIPTIONS_ERROR:
            return action.body.message;
    }
    return state;
}

export function subscriptions(state = null, action) {
    switch (action.type) {
        case FETCH_USER_SUBSCRIPTIONS_SUCCESS: {
            const { isEIP, maLegacyID, unsubscribeURL, subscriptions: values } = action.body;
            return {
                isEIP,
                maLegacyID,
                unsubscribeURL,
                values,
            };
        }
        case UPDATE_USER_SUBSCRIPTIONS_SUCCESS: {
            const { subscriptions: values } = action.options;
            return {
                ...state,
                values,
            };
        }
    }
    return state;
}
